import { parseAndCleanHtmlToReact } from 'helpers/HtmlHelpers';
import LandingPageLink from 'components/landing/LandingPageLink';
import LandingPageImage from 'components/landing/LandingPageImage';

import css from 'styles/components/landing/melodyArticleImageCopy.scss';

function makeHeading(heading) {
  return heading && <h2 className={css.heading}>{heading}</h2>;
}

function makeBody(body) {
  return body && parseAndCleanHtmlToReact(body);
}

function makeCopy(copy) {
  return copy && <p className={css.copy}>{copy}</p>;
}

function makeImageContents(slotDetails, onLandingComponentClick, shouldLazyLoad, slotIndex) {
  const { src, link, alt, gae, copy } = slotDetails;
  const linkProps = {
    'onClick': onLandingComponentClick,
    'data-eventlabel': 'melodyArticleImageCopy',
    'data-eventvalue': gae,
    'data-slotindex': slotIndex
  };
  const contents = (
    <>
      <LandingPageImage src={src} alt={alt} shouldLazyLoad={shouldLazyLoad} />
      {makeCopy(copy)}
    </>
  );
  return link
    ?
    <LandingPageLink url={link} {...linkProps}>
      {contents}
    </LandingPageLink>
    :
    contents;
}

const MelodyArticleImageCopy = ({ slotName, slotIndex, slotDetails, onLandingComponentClick, shouldLazyLoad }) => {
  const { heading, body, monetateId, subtitle } = slotDetails;
  return (
    <div
      className={css.wrap}
      data-slot-id={slotName}
      data-monetate-id={monetateId}
    >
      <div className={css.imgWrap}>
        {makeImageContents(slotDetails, onLandingComponentClick, shouldLazyLoad, slotIndex)}
      </div>
      <div className={css.contentWrap}>
        {makeHeading(heading)}
        {subtitle && <h3 className={css.subtitle}>{subtitle}</h3>}
        {makeBody(body)}
      </div>
    </div>
  );
};

export default MelodyArticleImageCopy;
